"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _iconForm = _interopRequireDefault(require("../components/iconForm"));
var _default = {
  components: {
    iconForm: _iconForm.default
  },
  data: function data() {
    return {
      iconList: []
    };
  },
  methods: {
    // 升序
    upSortItem: function upSortItem(index) {
      if (index === 0) {
        return;
      }
      var item = this.iconList[index];
      this.$set(this.iconList, index, this.iconList[index - 1]);
      this.$set(this.iconList, index - 1, item);
    },
    // 降序
    downSortItem: function downSortItem(index) {
      if (index === this.iconList.length - 1) {
        return;
      }
      var item = this.iconList[index];
      this.$set(this.iconList, index, this.iconList[index + 1]);
      this.$set(this.iconList, index + 1, item);
    },
    init: function init() {
      for (var i = 0; i < 10; i++) {
        this.iconList.push({
          img: '',
          title: '',
          jumpUrl: ''
        });
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
};
exports.default = _default;